"use client";

import { Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
export default function Footer() {
  const collectionLinks = [{
    label: "Newborn Essentials",
    to: "/NewbornParentsPage"
  }, {
    label: "Travel Kits",
    to: "/TravelHygienePage"
  }, {
    label: "Care Centers",
    to: "/ChildcareCentersPage"
  }, {
    label: "Our Mist",
    to: "/ProductPage"
  }, {
    label: "Journal",
    to: "/BlogPage"
  }, {
    label: "Help Center",
    to: "/FAQPage"
  }, {
    label: "Our Story",
    to: "/AboutPage"
  }];
  const informationLinks = [{
    label: "The B.Y.E. Story",
    to: "/AboutPage"
  }, {
    label: "Mist Science",
    to: "/ProductPage"
  }, {
    label: "Parenting Tips",
    to: "/NewbornParentsPage"
  }, {
    label: "Family Stories",
    to: "/AboutPage"
  }, {
    label: "Get in Touch",
    to: "/ContactPage"
  }, {
    label: "Common Questions",
    to: "/FAQPage"
  }];
  const connectLinks = [{
    label: "Instagram",
    to: "https://www.instagram.com/byehygiene",
    aria: "Follow us on Instagram"
  }, {
    label: "TikTok",
    to: "https://www.tiktok.com/@byehygiene",
    aria: "Follow us on TikTok"
  }, {
    label: "Facebook",
    to: "https://www.facebook.com/byehygiene",
    aria: "Follow us on Facebook"
  }, {
    label: "Email",
    to: "mailto:hello@byehygiene.com",
    aria: "Send us an email"
  }];
  const legalLinks = [{
    label: "Privacy Policy",
    to: "/PrivacyPolicyPage"
  }, {
    label: "Terms of Use",
    to: "/TermsOfServicePage"
  }, {
    label: "Shipping & Returns",
    to: "/ShippingReturnsPage"
  }];
  return <section data-section-id="5226" id="footer" className="bg-cream-warm text-sage-deep px-6 md:px-12 pt-20 md:pt-[120px] pb-12">
      <div className="mx-auto max-w-[1600px]">
        <Separator className="bg-border-subtle" />

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8 py-12 md:py-16">
          <div data-index={0} className="flex flex-col gap-4">
            <Link to="/" className="block w-fit">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <address className="font-default not-italic text-[14px] leading-relaxed text-sage-deep/90">
              Before You Enter™
              <br />
              Creating gentle rituals for the
              <br />
              modern family, wherever
              <br />
              life takes you.
            </address>
            <Link to="mailto:hello@byehygiene.com" className="font-default italic text-[14px] text-sage-deep/90 hover:text-accent-gold transition-colors w-fit">
              hello@byehygiene.com
            </Link>
          </div>

          <div data-index={1} className="flex flex-col gap-4">
            <span className="font-default text-[12px] uppercase text-sage-deep/60" style={{
            letterSpacing: "0.18em"
          }}>
              <strong>Pillar Pages</strong>
            </span>
            <ul className="flex flex-col gap-3">
              {collectionLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="group font-default text-[12px] uppercase text-sage-deep/90 hover:text-accent-gold transition-colors inline-block" style={{
                letterSpacing: "0.18em"
              }}>
                    <span className="border-b border-transparent group-hover:border-accent-gold pb-0.5 transition-colors">
                      {item.label}
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-index={2} className="flex flex-col gap-4">
            <span className="font-default text-[12px] uppercase text-sage-deep/60" style={{
            letterSpacing: "0.18em"
          }}>
              <strong>Resources</strong>
            </span>
            <ul className="flex flex-col gap-3">
              {informationLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="group font-default text-[12px] uppercase text-sage-deep/90 hover:text-accent-gold transition-colors inline-block" style={{
                letterSpacing: "0.18em"
              }}>
                    <span className="border-b border-transparent group-hover:border-accent-gold pb-0.5 transition-colors">
                      {item.label}
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-index={3} className="flex flex-col gap-4">
            <span className="font-default text-[12px] uppercase text-sage-deep/60" style={{
            letterSpacing: "0.18em"
          }}>
              <strong>Community</strong>
            </span>
            <p className="font-default text-[14px] leading-relaxed text-sage-deep/80">
              Join our family-focused community for support and shared experiences.
            </p>
            <ul className="flex flex-col gap-3">
              {connectLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} aria-label={item.aria} className="group font-default text-[12px] uppercase text-sage-deep/90 hover:text-accent-gold transition-colors inline-flex items-center gap-2" style={{
                letterSpacing: "0.18em"
              }}>
                    {item.label === "Email" && <Mail className="size-3" aria-hidden="true" />}
                    <span className="border-b border-transparent group-hover:border-accent-gold pb-0.5 transition-colors">
                      {item.label}
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 py-8">
          <Link to="/ShopPage" className="px-8 py-3 bg-accent-gold text-white-pure rounded-lg font-default text-[14px] uppercase tracking-wider hover:brightness-90 transition-all shadow-md">
            Shop Now
          </Link>
          <Link to="#" className="px-8 py-3 border border-sage-deep text-sage-deep rounded-lg font-default text-[14px] uppercase tracking-wider hover:bg-sage-deep hover:text-cream-warm transition-all">
            Contact Us
          </Link>
          <Link to="/AboutPage" className="px-8 py-3 border border-sage-deep text-sage-deep rounded-lg font-default text-[14px] uppercase tracking-wider hover:bg-sage-deep hover:text-cream-warm transition-all">
            Follow Our Journey
          </Link>
        </div>

        <div className="text-center pb-8">
          <p className="font-default text-[12px] uppercase tracking-[0.2em] text-sage-deep/40">
            Trusted by families worldwide
          </p>
        </div>

        <Separator className="bg-border-subtle" />

        <div className="py-10 md:py-16 w-full overflow-hidden">
          <h2 className="font-default font-medium text-sage-deep leading-none w-full" style={{
          fontSize: "clamp(80px, 22vw, 320px)",
          letterSpacing: "-0.05em"
        }}>
            B.Y.E.
            <span className="text-accent-gold">.</span>
          </h2>
        </div>

        <Separator className="bg-border-subtle" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pt-8">
          <p className="font-default text-[11px] uppercase text-sage-deep/60 order-1" style={{
          letterSpacing: "0.12em"
        }}>
            © 2024 B.Y.E. Hygiene – Thank you for being part of our family
          </p>

          <div className="flex items-center gap-2 order-3 md:order-2" aria-hidden="true">
            <span className="block size-1.5 rounded-lg animate-pulse bg-accent-gold" style={{
            animationDuration: "2s"
          }} />
          </div>

          <div className="flex items-center gap-3 order-2 md:order-3">
            {legalLinks.map((item, i) => <div key={item.label} data-index={i} className="flex items-center gap-3">
                <span className="font-default text-[11px] text-sage-deep/60" aria-hidden="true">
                  /
                </span>
                <Link to={item.to} className="font-default text-[11px] uppercase text-sage-deep/60 hover:text-accent-gold transition-colors" style={{
              letterSpacing: "0.12em"
            }}>
                  {item.label}
                </Link>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}